var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{'active' : _vm.isActiveLnb }},[_c('router-link',{staticClass:"link_lnb",attrs:{"to":{name : _vm.lnbMenu.routerPath }}},[_c('span',{staticClass:"txt_menu"},[_vm._v(_vm._s(_vm.lnbMenu.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }